import BankAccountDropdown from "components/dropdowns/reactselect/BankAccountDropdown";
import { useValidateIsNotNull } from "formvalidation/hooks";
import React from "react";

interface Props {
  value: server.dto.BankAccountSmall;
  onChange: (bankAccount: server.dto.BankAccountSmall) => void;
  options: server.dto.BankAccountSmall[];
}

const SelectBankAccount = (props: Props) => {
  const validation = useValidateIsNotNull({ key: "bankAccount", title: RESX.BankAccount.resxBankAccount, value: props.value, });

  const onBankAccountChange = (bankAccount: server.dto.BankAccountSmall) => {
    props.onChange(bankAccount);
  }

  return <div ref={validation.ref}>
    <BankAccountDropdown
      value={props.value}
      onChange={onBankAccountChange}
      options={props.options ?? []}
      config={{ hasError: validation.error.hasError }} />
  </div>
};

export default SelectBankAccount;